export class DebounceConstants {
   public static readonly DEFAULT_DEBOUNCE = 500;
}
